<template>
  <div>
    <CRow>
      <CCol sm="12">
        <BanksTable
          :items="banks"
          hover
          striped
          border
          small
          fixed
          caption="Cuentas Bancarias"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BanksTable from '../../components/banks/BanksTable.vue'
import ws from '../../services/bank_accounts';
import store from '../../store'

export default {
  name: 'Banks',
  components: { BanksTable },
  data: function () {
		return {
            banks: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.banks = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.banks = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
